import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsRadiopublicComponent } from './simple-icons-radiopublic.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsRadiopublicComponent ],
    exports:      [ SimpleIconsRadiopublicComponent ],
    bootstrap:    []
})
export class SimpleIconsRadiopublicModule {}
